<!-- mobile  -->
<div class="app-website">
    <div class="HVB-contnet dynamic-banner-top-slider HU-banner c-bg d-block d-lg-none">
        <div id="myCarousel1" class="carousel slide" data-ride="carousel" [noPause]=true data-pause="false"
            data-interval="14000">
            <div class="container-fluid bg-dark d-block d-lg-none">
                <div class="row bg-dark home-web-carousel">
                    <div [hidden]="bannerList && bannerList?.length === 0" class="carousel-container">
                        <div class="carousel-inner slider-height o-inherit">
                            <div *ngFor="let a of bannerList; let i = index" id="mobile-carousel-{{i}}"
                                [ngClass]="{
                                    'carousel-item': i >= 1 || bannerList?.length == 1,
                                    'active': (i == 1 || bannerList?.length == 1),
                                    'd-none': (i == 0 && bannerList?.length > 1)
                                }">
                                <div *ngIf="a.isEvent == 'upcoming' || a.isEvent == 'albums' || a.isEvent == 'product' || a.isEvent == 'nft'" 
                                    class="content-bg">
                                    <div class="pl7 pr7">
                                        <div class="view-drop row">
                                            <div class="pos-abs">
                                            </div>
                                            <div class="type-tag-mobile">
                                                <span *ngIf="a.isEvent == 'upcoming'">Event</span>
                                                <span *ngIf="a.isEvent == 'albums'">Album</span>
                                                <span *ngIf="a.isEvent == 'product'">Merch</span>
                                                <span *ngIf="a.isEvent == 'nft'">NFT</span>
                                            </div>
                                            <div class="col-12">
                                                <h2 class="mobile-header">{{a.stream_video_title}}</h2>
                                                <div class="drop-image"
                                                    [style.background-image]="'url(' + a.event_home_banner + ')'">
                                                </div>
                                            </div>
                                            <div class="col-12 view-drop-right">
                                                <div class="profile">
                                                    <div class="dp" *ngIf="a.organization_logo"
                                                        [style.background-image]="'url(' + a.organization_logo + ')'">
                                                    </div>
                                                    <!-- <div class="no-dp" *ngIf="!a.organization_logo">A</div> -->
                                                    <h6 class="name text-capitalize" *ngIf="a.organization_name">
                                                        {{a.organization_name}}
                                                    </h6>
                                                </div>
                                                <h3 class="album-drop-text">
                                                    {{displayMultipleTime[i]?.message || 'Loading...'}}
                                                </h3>
                                                
                                                <!-- Timer countdown - Use safe index access -->
                                                <div class="timer" *ngIf="displayMultipleTime[i]?.showTimer">
                                                    <div class="box box-color">
                                                        <div>
                                                            <label class="time">{{displayMultipleTime[i]?.days || 0}}</label>
                                                            <p class="time-label">
                                                                <span *ngIf="displayMultipleTime[i]?.days != 1">Days</span>
                                                                <span *ngIf="displayMultipleTime[i]?.days == 1">Day</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="box box-color">
                                                        <div>
                                                            <label class="time">{{displayMultipleTime[i]?.hours || 0}}</label>
                                                            <p class="time-label">
                                                                <span *ngIf="displayMultipleTime[i]?.hours != 1">Hours</span>
                                                                <span *ngIf="displayMultipleTime[i]?.hours == 1">Hour</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="box box-color">
                                                        <div>
                                                            <label class="time">{{displayMultipleTime[i]?.minutes || 0}}</label>
                                                            <p class="time-label">
                                                                <span *ngIf="displayMultipleTime[i]?.minutes != 1">Minutes</span>
                                                                <span *ngIf="displayMultipleTime[i]?.minutes == 1">Minute</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="box box-color">
                                                        <div>
                                                            <label
                                                             class="time">{{displayMultipleTime[i]?.seconds || 0}}</label>
                                                            <p class="time-label">Seconds</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center">
                                                    <ng-container *ngIf="a.isEvent == 'upcoming'">
                                                        <button fxShow fxHide.xs="true"
                                                            *ngIf="a.isTicketPurchased && a.selected_type =='single_session_event'"
                                                            mat-flat-button class="drop-btn"
                                                            (click)="redirectTo(a,'stream')">Go to
                                                            Stream</button>
                                                        <button fxShow fxHide.xs="true"
                                                            *ngIf="a.isTicketPurchased && a.selected_type !='single_session_event'"
                                                            mat-flat-button class="drop-btn"
                                                            (click)="redirectTo(a,'schedule')">Go to
                                                            schedule</button>
                                                        <button mat-flat-button
                                                            *ngIf="a.isEvent == 'upcoming' && !a.isTicketPurchased"
                                                            class="drop-btn" 
                                                            (click)="goToEventReg(a)">
                                                            <span *ngIf="displayMultipleTime[i]?.message == 'Sale starts in ...'">
                                                                View Details
                                                            </span>
                                                            <span *ngIf="displayMultipleTime[i]?.message != 'Sale starts in ...'">
                                                                Get Tickets
                                                            </span>
                                                        </button>
                                                        <button fxShow fxHide.xs="true" mat-flat-button
                                                            *ngIf="a.isEvent == 'channels'" class="drop-btn"
                                                            routerLink="/c/{{a.channel_name}}/profile">View</button>
                                                    </ng-container>
                                                    <ng-container *ngIf="a.isEvent == 'albums' || a.isEvent == 'product'">
                                                        <button mat-flat-button class="drop-btn" (click)="goToEventReg(a)">
                                                            <span *ngIf="a.isEvent == 'albums'">View Album</span>
                                                            <span *ngIf="a.isEvent == 'product'">
                                                                <span *ngIf="displayMultipleTime[i]?.message == 'Drop starts in ...'">
                                                                    View Product
                                                                </span>
                                                                <span *ngIf="displayMultipleTime[i]?.message == 'Drop ends in ...'">
                                                                    Buy Now
                                                                </span>
                                                            </span>
                                                        </button>
                                                    </ng-container>
                                                    
                                                    <!-- NFTs -->
                                                    <ng-container *ngIf="a.isEvent == 'nft' && 
                                                        (displayMultipleTime[i]?.message == 'Sale ends in ...' || 
                                                        displayMultipleTime[i]?.message == 'Drop ends in ...' || 
                                                        displayMultipleTime[i]?.message == 'Drop ended')">
                                                        <button mat-flat-button class="drop-btn" 
                                                            (click)="goToEventReg(a)" 
                                                            *ngIf="a['number_of_copies_for_sale'] > 0">
                                                            <span *ngIf="a.saleType == 'instant'">Buy Now</span>
                                                            <span *ngIf="a.saleType == 'auction'">Make a Bid</span>
                                                            <span *ngIf="a.saleType == 'lazymint'">Buy Now</span>
                                                        </button>
                                                        <button mat-flat-button class="drop-btn cursor-def" 
                                                            *ngIf="a['number_of_copies_for_sale'] <= 0">
                                                            Sold Out
                                                        </button>
                                                    </ng-container>
                                                    
                                                    <ng-container *ngIf="a.isEvent == 'nft' && 
                                                        displayMultipleTime[i]?.message == 'Sale starts in ...'">
                                                        <button mat-flat-button class="drop-btn" 
                                                            (click)="goToEventReg(a)" 
                                                            *ngIf="a['number_of_copies_for_sale'] > 0">
                                                            View NFT
                                                        </button>
                                                        <button mat-flat-button class="drop-btn cursor-def" 
                                                            *ngIf="a['number_of_copies_for_sale'] <= 0">
                                                            Sold Out
                                                        </button>
                                                    </ng-container>     
                                                </div>
                                                <!-- <div class="dropdown d-flex justify-content-center pt-10">
                                                    <button class="btn btn-secondary" type="button" id="dropdownMenu2"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false" [ngClass]="{'text-info':isShown}"> <i
                                                            class="fa fa-share-alt mr-2" aria-hidden="true"
                                                            (click)="toggleShow()"></i><span
                                                            (click)="toggleShow()">Share</span>
                                                    </button>
                                                    <div [hidden]="!isShown" #menu class="social-icons-div mt-2">
                                                        <app-social-share-link [sharedFrom]="a.isEvent"
                                                            [slugName]="a.url"></app-social-share-link>
                                                    </div>
                                                </div> -->
                                                
                                                <!-- Share section -->
                                                <h4 class="pointer ff d-flex justify-content-center pt-10" 
                                                    (click)="toggleShow()">
                                                    <span [ngClass]="{'text-info': socialShareClick}">
                                                        <i class="fa fa-share-alt mr-2" aria-hidden="true"></i>
                                                        <span>Share</span>
                                                    </span>
                                                    <span class="ml-10 left-border"></span>
                                                </h4>
                                                
                                                <div *ngIf="socialShareClick" class="position-ab bg-dark">
                                                    <div (click)="toggleShow()" [hidden]="!isShown" #menu class="social-icons-div mt-2">
                                                        <i class="fa fa-times icon-buttons-secondary p-3"></i>
                                                    </div>
                                                    <app-social-share-link 
                                                        [sharedFrom]="a.isEvent"
                                                        [slugName]="a.url">
                                                    </app-social-share-link>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                            
                            <!-- Carousel indicators -->
                            <ol class="carousel-indicators pt-20" [hidden]="bannerList?.length == 1">
                                <li *ngFor="let a of bannerList; let i = index" 
                                    [ngClass]="{'active': i == 1}"
                                    data-target="#myCarousel1" 
                                    [attr.data-slide-to]="i"
                                    [hidden]="i == 0"
                                    (click)="selectImage(i)">
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!-- upcoming events web starts-->
    <div class="container-fluid bg-dark d-none d-lg-block">
        <div class="row bg-dark home-web-carousel">
            <div [hidden]=" bannerList && bannerList?.length === 0" class="carousel-container">
                <ng-container *ngFor="let a of bannerList; let i = index">
                    <div [hidden]="!displayMultipleTime[displayTimerIndex]['removeFromDrop']" (mouseover)="over()"
                        (mouseout)="out()"
                        *ngIf="selectedIndex===i && (a.isEvent == 'upcoming' || a.isEvent == 'albums' || a.isEvent == 'product' || a.isEvent == 'nft')"
                        class="content-bg gradient-bg-color">
                        <div class="pl7 pr7">
                            <div class="pos-abs">
                            </div>
                            <div class="type-tag-web">
                                <span *ngIf="a.isEvent == 'upcoming'">Event</span>
                                <span *ngIf="a.isEvent == 'albums'">Album</span>
                                <span *ngIf="a.isEvent == 'product'">Merch</span>
                                <span *ngIf="a.isEvent == 'nft'">NFT</span>
                            </div>
                            <div class="view-drop row">
                                <div class="col-6">
                                    <div style="padding-left:9%;padding-right:7%;">
                                        <div class="drop-image"
                                            [ngStyle]="{'background-image': 'url(' + a.event_home_banner + ')'}"></div>
                                    </div>
                                </div>
                                <div class="col-6 view-drop-right">
                                    <div class="profile">
                                        <div class="dp" *ngIf="a.organization_logo"
                                            [ngStyle]="{'background-image': 'url(' + a.organization_logo + ')'}"></div>
                                        <div class="no-dp" *ngIf="!a.organization_logo">A</div>
                                        <h6 class="name text-capitalize" *ngIf="a.organization_name">
                                            {{a.organization_name}}</h6>
                                    </div>
                                    <h2 class="header">{{a.stream_video_title}}</h2>
                                    <h3 class="album-drop-text">{{displayMultipleTime[displayTimerIndex]['message']}}
                                    </h3>
                                    <div class="timer" *ngIf="displayMultipleTime[displayTimerIndex]['showTimer']">
                                        <div class="box box-color">
                                            <div>
                                                <label
                                                    class="time">{{displayMultipleTime[displayTimerIndex]['days']}}</label>
                                                <p class="time-label">
                                                    <span
                                                        *ngIf="displayMultipleTime[displayTimerIndex]['days']!=1">Days</span>
                                                    <span
                                                        *ngIf="displayMultipleTime[displayTimerIndex]['days']==1">Day</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="box box-color">
                                            <div>
                                                <label
                                                    class="time">{{displayMultipleTime[displayTimerIndex]['hours']}}</label>
                                                <p class="time-label">
                                                    <span
                                                        *ngIf="displayMultipleTime[displayTimerIndex]['hours']!=1">Hours</span>
                                                    <span
                                                        *ngIf="displayMultipleTime[displayTimerIndex]['hours']==1">Hour</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="box box-color">
                                            <div>
                                                <label
                                                    class="time">{{displayMultipleTime[displayTimerIndex]['minutes']}}</label>
                                                <p class="time-label">
                                                    <span
                                                        *ngIf="displayMultipleTime[displayTimerIndex]['minutes']!=1">Minutes</span>
                                                    <span
                                                        *ngIf="displayMultipleTime[displayTimerIndex]['minutes']==1">Minute</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="box box-color">
                                            <div>
                                                <label
                                                    class="time">{{displayMultipleTime[displayTimerIndex]['seconds']}}</label>
                                                <p class="time-label">Seconds</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <!-- <div class="btn-effect">
                                        <div class="effect-1 banner-e-btn"></div>
                                        <div class="effect-2 banner-e-btn"></div>
                                        <div class="effect-3 banner-e-btn"></div> -->
                                        <ng-container *ngIf="a.isEvent == 'upcoming'">
                                            <button fxShow fxHide.xs="true"
                                                *ngIf="a.isTicketPurchased && a.selected_type =='single_session_event'"
                                                mat-flat-button class="drop-btn" (click)="redirectTo(a,'stream')">Go to
                                                Stream</button>
                                            <button fxShow fxHide.xs="true"
                                                *ngIf="a.isTicketPurchased && a.selected_type !='single_session_event'"
                                                mat-flat-button class="drop-btn" (click)="redirectTo(a,'schedule')">Go
                                                to
                                                schedule</button>
                                            <button mat-flat-button
                                                *ngIf="a.isEvent == 'upcoming' && !a.isTicketPurchased" class="drop-btn"
                                                (click)="goToEventReg(a)">
                                                <span
                                                    *ngIf="displayMultipleTime[displayTimerIndex]['message'] == 'Sale starts in ...'">View
                                                    Details</span>
                                                <span
                                                    *ngIf="displayMultipleTime[displayTimerIndex]['message'] != 'Sale starts in ...'">Get
                                                    Tickets</span>
                                            </button>
                                            <button fxShow fxHide.xs="true" mat-flat-button
                                                *ngIf="a.isEvent == 'channels'" class="drop-btn"
                                                routerLink="/c/{{a.channel_name}}/profile">View</button>
                                        </ng-container>
                                        <ng-container *ngIf="a.isEvent == 'albums' || a.isEvent == 'product'">
                                            <button mat-flat-button class="drop-btn" (click)="goToEventReg(a)">
                                                <span *ngIf="a.isEvent == 'albums'">View Album</span>
                                                <span *ngIf="a.isEvent == 'product'">
                                                    <span *ngIf="displayMultipleTime[displayTimerIndex]['message'] == 'Drop starts in ...'">
                                                        View Product
                                                    </span>
                                                    <span *ngIf="displayMultipleTime[displayTimerIndex]['message'] == 'Drop ends in ...'">
                                                        Buy Now
                                                    </span>
                                                </span>
                                            </button>
                                        </ng-container>
                                        <ng-container *ngIf="a.isEvent == 'nft' &&
                                        (displayMultipleTime[displayTimerIndex]['message'] == 'Sale ends in ...'
                                        || displayMultipleTime[displayTimerIndex]['message'] == 'Drop ends in ...'
                                        || displayMultipleTime[displayTimerIndex]['message'] == 'Drop ended')">
                                            <button mat-flat-button class="drop-btn" (click)="goToEventReg(a)" *ngIf="a['number_of_copies_for_sale']>0"> 
                                                <span *ngIf="a.saleType == 'instant'">Buy Now</span>
                                                <span *ngIf="a.saleType == 'auction'">Make a Bid</span>
                                                <span *ngIf="a.saleType == 'lazymint'">Buy Now</span>                  
                                            </button>
                                            <button mat-flat-button class="drop-btn cursor-def" *ngIf="a['number_of_copies_for_sale']<=0"> 
                                                Sold Out
                                            </button>
                                        </ng-container>
                                        <ng-container *ngIf="a.isEvent == 'nft' && displayMultipleTime[displayTimerIndex]['message'] == 'Sale starts in ...'">
                                            <button mat-flat-button class="drop-btn" (click)="goToEventReg(a)" *ngIf="a['number_of_copies_for_sale']>0"> 
                                                View NFT               
                                            </button>
                                            <button mat-flat-button class="drop-btn cursor-def" *ngIf="a['number_of_copies_for_sale']<=0"> 
                                                Sold Out
                                            </button>
                                        </ng-container>      
                                        <!-- </div> -->
                                    </div>
                                    <div class="d-flex justify-content-center dropdown pt-10">
                                        <button class="btn btn-secondary" type="button" id="dropdownMenu2"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                            [ngClass]="{'text-info':isShown}"> <i class="fa fa-share-alt mr-2"
                                                aria-hidden="true" (click)="toggleShow()"></i><span
                                                (click)="toggleShow()">Share</span>
                                        </button>
                                        <div *ngIf="isShown" #menu class="social-icons-div mt-2">
                                           <span (click)="shareClose()"><i class="pointer f-r fa fa-times icon-buttons-secondary p-3"></i></span> 
                                         
                                            <app-social-share-link sharedFrom="event" [channelName]="a.channel_name" [slugName]="a.url">
                                            </app-social-share-link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="carousel-dot-container" id="event-container" (scroll)="scrolled($event)">
                    <span *ngFor="let a of bannerList; let i = index" class="home-act relative"
                        [ngClass]="{'dot': i>0 || bannerList?.length == 1, 'active':selectedIndex===i,'d-none':!a.removeFromDrop}"
                        [ngStyle]="{'background-image': (a.event_home_banner !==undefined) && (deviceInfo=='android' || deviceInfo=='ios') ? 'url(' + a.event_home_banner + ')' : 'url(' + a.video_banner_image + ')'}"
                        (click)="selectImage(i)">
                        <div class="event-details" *ngIf="!isShowFirstVideo(i) && selectedIndex===i">
                            <span class="event-date-time p-1">
                                <span class="event-date-name">
                                    {{a.stream_video_title | uppercase}}</span>
                                <span class="d-block text-center" *ngIf="a.org_publish_date_time && a.expected_end_date_time && a.org_publish_date_time != 'null' && a.expected_end_date_time !='null'">
                                    {{a.banner_dates}}
                                </span>
                            </span>
                        </div>
                        <video [muted]="'true'" *ngIf="isShowFirstVideo(i) && bannerList?.length == 1"
                            src="https://uploads-prod.arevea.com/homepage_video.mp4" id="banner-video" autoplay
                            playsinline [muted]="'muted'" loop class="video100"
                            [poster]="assets_url + 'home-page/home-page-video-banner.png'" loop>
                        </video>
                    </span>

                </div>
            </div>
            <div *ngIf="scrollpos" class="scroll__progress">
                <div class="scroll__bar mt-90">
                    <span class="scroll__bar-thumb"
                        [ngStyle]="{'transform': 'translate('+scrollPosition+'%, 0px) scale(0.126, 1)'}"></span>
                </div>
            </div>
        </div>
    </div>
    <!-- <div id="myCarousel2" class="nft carousel slide" data-ride="carousel" [noPause]=true data-pause="false"
        data-interval="14000">
        <div class="carousel-inner nft-carousel">
            <div *ngFor="let nft of nft_raw_data ;let i =index" id="{{i}}"
                [ngClass]="{'carousel-item': i>=0 || nft_raw_data?.length == 1,'active' : (i == 0 || nft_raw_data?.length == 1)}">
                <div class="pl7 pr7">
                    <div class="row">
                        <div class="text-center w-100"><h1 class="header d-block d-md-none text-center">Discover, collect, and Sell NFTs</h1></div>
                        <div class="col-md-6 col-lg-8 nft-left d-none d-md-block">
                            <h1 class="header">Discover, collect, and Sell NFTs</h1>
                            <div class="d-flex mt-4 align-items-center">
                                <div class="dp"></div>
                                <h6 class="name ml-4 text-capitalize">{{nft.org}}</h6>
                            </div>
                            <h2 class="fs-26 my-4">{{nft.title}}</h2>
                            <p class="pr-4">{{nft.content}}</p>
                            <button class="explore-btn flat-primary-button">Explore</button>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 nft-right">
                            <div class="nft-image d-flex align-items-end"  [ngStyle]="{'background-image': 'url(' + nft.image + ')'}">
                                <div class="d-block d-md-none content">
                                    <h2 class="fs-26 my-2">Dogg on it: Death Row Mixtape Vol. 1</h2>
                                    <p class="pr-4">Bacc on Death Row.<br>
                                        For the first time ever, Snoop Dogg is dropping a mixtape as an NFT. First edition,
                                        Dogg on it.The mixtape includes beats, acapellas, full songs, all from artists from
                                        around the world. All Death Row.</p>
                                </div>
                            </div>
                            <button class="explore-btn flat-primary-button d-md-none">Explore</button>
                        </div>
                    </div>
                </div>
            </div>
            <ol class="carousel-indicators pt-20">
                <li *ngFor="let a of nft_raw_data;let i =index" [ngClass]="{'active' : i == 0}" [attr.data-slide-to]="i"
                    data-target="#myCarousel2" class="active"></li>
            </ol>
        </div>
    </div> -->
    <!-- upcoming events web ends -->
    <div class="homev3 bg-dark">
        <!-- section2 -->
        <section class="section7">
            <div class="row align-items-center be-informed-section h-100 content-bg custom-bg-color">

                <div class="col-12 header col-md-7 text-left">
                    <h1 class="text-info">BE INFORMED</h1>
                    <p class="fw-400">
                        Receive notifications for upcoming events
                    </p>
                </div>
                <div class="col-12 email-section col-md-5 pos text-left">
                    <div>
                        <!-- <input placeholder="Enter your E-mail"> -->
                        <form [formGroup]="contactInformtionForm">
                            <mat-form-field class="w-100">
                                <!-- <mat-label>Enter your E-mail</mat-label> -->
                                <input matInput placeholder="Enter your E-mail" class="custom-field m-0"
                                    formControlName="user_email" required>
                                <mat-error *ngIf="contactInformtionForm.get('user_email').hasError('required')">
                                    Please enter email
                                </mat-error>
                                <mat-error *ngIf="contactInformtionForm.get('user_email').hasError('email')">
                                    Please enter valid email
                                </mat-error>
                            </mat-form-field>
                            <button mat-flat-button class="flat-primary-button primary-bg-button text-uppercase"
                            (click)="contactButton()">CONTACT US</button>
                        </form>
                        <!-- <div class="btn-effect">
                            <div class="effect-1"></div>
                            <div class="effect-2"></div>
                            <div class="effect-3"></div> -->
                       
                        <!-- <button mat-flat-button class="mt-15 flat-primary-button fw-500" routerLink="/contactus" (click)="contactButton()">CONTACT US</button> -->
                        <!-- </div> -->
                    </div>
                </div>
            </div>


        </section>
        <!-- section3 -->
        <section class="mt-90 d-none d-lg-block" *ngIf="channelarray  && channelarray.length > 0">
            <div class="section3 section3Header">FEATURED N<span class="network-style">ETWORKS</span></div>
            <div class="row w-100 align-item-center justify-content-center">
                <div class="col-3 pl-2">
                    <div class="featured-network">
                        <div *ngFor="let data of sliderArray;let i=index">
                            <ng-container *ngFor="let d of  data.dataArray;let j=index">
                                <div *ngIf="(j==0 || j==2 || j==4) && data?.dataArray?.length>1"
                                    class="tagImgNew active pointer"
                                    [ngClass]="{'vertical-box': data.is_vertical ,'horizontal-box': !data.is_vertical} ">
                                    <ng-container *ngIf="d?.video_thumbnail_image">
                                        <div *ngIf="d.static"
                                            [ngStyle]="{'background-image': 'url(' + d.video_thumbnail_image + ')' }"
                                            class="banner-image-area-new bgc home-act"
                                            [ngClass]="{'img-active' : d.channel_name == this.selectedChannel.channel_name }"
                                            (click)="dispalyChannel(d)">
                                        </div>
                                        <div *ngIf="!d.static"
                                            [ngStyle]="{'background-image': 'url(' + d.event_home_banner + ')' }"
                                            class="banner-image-area-new pointer home-act"
                                            [ngClass]="{'bgC': !data.is_vertical, 'bg100' : data.is_vertical, 'img-active' : d.channel_name == this.selectedChannel.channel_name  }"
                                            (click)="dispalyChannel(d)">
                                            <!-- <div class="cname"><span
                                                class="align-middle name">{{d.channel_display_name}}</span></div> -->
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!d?.video_thumbnail_image">
                                        <ng-container *ngIf="!data.is_vertical">
                                            <img [src]="assets_url + 'home-updateHoriz.png'" class="banner-image-area">
                                        </ng-container>
                                        <ng-container *ngIf="data.is_vertical">
                                            <img [src]="assets_url + 'home-updateVerti.png'" class="banner-image-area">
                                        </ng-container>
                                    </ng-container>
                                </div>


                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-6 text-center pl-15">
                    <!-- <div *ngFor="let data of sliderArray;let i=index">
<div *ngFor="let d of  data.dataArray">
    <h1 *ngIf="d?.video_thumbnail_image && d.channel_name == this.selectedChannel.channel_name" (click)="dispalyChannel(d)" class=event-title>{{d.channel_display_name}}</h1>
</div>
                </div> -->
                    <h1 class=event-title>{{selectedChannel?.channel_display_name}}</h1>

                    <div class="event"
                        [ngStyle]="{'background-image': ' url(' + selectedChannel?.channel_banner_img + ')' }">
                    </div>
                    <!-- <div class="btn-effect">
                        <div class="effect-1 enter-e-btn"></div>
                        <div class="effect-2 enter-e-btn"></div>
                        <div class="effect-3 enter-e-btn"></div> -->
                    <button mat-flat-button class="mt-15 enter-btn flat-primary-button  tertiary-bg-button mb-50"
                        (click)="enterChannel()">ENTER</button>
                    <!-- </div> -->
                </div>
                <div class="col-3 pl-4 pr-25">
                    <div class="featured-network">
                        <div *ngFor="let data of sliderArray;let i=index">
                            <ng-container *ngFor="let d of  data.dataArray;let j=index">

                                <div *ngIf="j==1 ||j==3 || j==5" class="tagImgNew pointer"
                                    [ngClass]="{'vertical-box': data.is_vertical ,'horizontal-box': !data.is_vertical} ">
                                    <ng-container *ngIf="d?.video_thumbnail_image">
                                        <div *ngIf="d.static"
                                            [ngStyle]="{'background-image': 'url(' + d.video_thumbnail_image + ')','background-position':'center','background-repeat':'no-repeat'  }"
                                            class="banner-image-area-new bgc home-act"
                                            [ngClass]="{'img-active' : d.channel_name == this.selectedChannel.channel_name }"
                                            (click)="dispalyChannel(d)">
                                        </div>
                                        <div *ngIf="!d.static"
                                            [ngStyle]="{'background-image': 'url(' + d.event_home_banner + ')','background-position':'center','background-repeat':'no-repeat'  }"
                                            class="banner-image-area-new pointer home-act"
                                            [ngClass]="{'bgC': !data.is_vertical, 'bg100' : data.is_vertical, 'img-active' : d.channel_name == this.selectedChannel.channel_name  }"
                                            (click)="dispalyChannel(d)">
                                            <!-- <div class="cname"><span
                                                class="align-middle name">{{d.channel_display_name}}</span></div> -->
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!d?.video_thumbnail_image">
                                        <ng-container *ngIf="!data.is_vertical">
                                            <img [src]="assets_url + 'home-updateHoriz.png'" class="banner-image-area">
                                        </ng-container>
                                        <ng-container *ngIf="data.is_vertical">
                                            <img [src]="assets_url + 'home-updateVerti.png'" class="banner-image-area">
                                        </ng-container>
                                    </ng-container>
                                </div>


                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- section3 responsive -->
        <!-- mobile resonsive section3 -->
        <section class="mt-20 d-block d-lg-none" *ngIf="channelarray  && channelarray.length > 0">
            <div class="section3 section3Header">FEATURED N<span class="network-style">ETWORKS</span></div>
            <!-- <div class="section3 section3Header">FEATURED N<span style="border-bottom: 4px solid #95E2CC;padding-left: 30px;">ETWORKS</span></div> -->
            <!-- <div class="row w-100 align-item-center justify-content-center" data-toggle="modal" data-target="#exampleModalCenter"> -->
            <div class="row w-100 align-item-center justify-content-center">
                <div class="col-12">
                    <div class="featured-network">
                        <div *ngFor="let data of sliderArray;let i=index">
                            <ng-container *ngFor="let d of  data.dataArray;let j=index ">
                                <div *ngIf="j<6" class="tagImgNew mb-110 active pointer"
                                    [ngClass]="{'vertical-box': data.is_vertical ,'horizontal-box': !data.is_vertical, 'img-active' : d.channel_name == this.selectedChannel.channel_name} "
                                    (click)="dispalyChannel(d,'mobile')">
                                    <ng-container *ngIf="d?.video_thumbnail_image">
                                        <div *ngIf="d.static"
                                            [ngStyle]="{'background-image': ' url(' + d.video_thumbnail_image + ')','background-position':'center','background-repeat':'no-repeat'  }"
                                            class="banner-image-area-new bgc home-act"
                                            [ngClass]="{'img-active' : d.channel_name == this.selectedChannel.channel_name }">
                                        </div>
                                        <div *ngIf="!d.static"
                                            [ngStyle]="{'background-image': ' url(' + d.event_home_banner + ')','background-position':'center','background-repeat':'no-repeat'  }"
                                            class="banner-image-area-new pointer home-act"
                                            [ngClass]="{'bgC': !data.is_vertical, 'bg100' : data.is_vertical, 'img-active' : d.channel_name == this.selectedChannel.channel_name}">
                                            <!-- <div class="cname"><span class="align-middle name">{{d.channel_display_name}}</span>
                                            </div> -->
                                        </div>
                                        <h1 *ngIf="d.channel_display_name" class="event-title">
                                            {{d.channel_display_name}}</h1>

                                    </ng-container>
                                    <ng-container *ngIf="!d?.video_thumbnail_image">
                                        <ng-container *ngIf="!data.is_vertical">
                                            <img [src]="assets_url + 'home-updateHoriz.png'" class="banner-image-area">
                                        </ng-container>
                                        <ng-container *ngIf="data.is_vertical">
                                            <img [src]="assets_url + 'home-updateVerti.png'" class="banner-image-area">
                                        </ng-container>
                                    </ng-container>
                                </div>


                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">

                        </div>
                        <div class="modal-body">
                            <div class="text-center">
                                <div class="event-modal"
                                    [ngStyle]="{'background-image': ' url(' + selectedChannel?.channel_banner_img + ')'}">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-center">
                            <button mat-flat-button class="my-2 flat-primary-button tertiary-bg-button fw-500 "
                                data-dismiss="modal" (click)="enterChannel()">Enter </button>
                            <!-- 
                      <button type="button" class="btn btn-primary">Save changes</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Feature video content  -->
        <div class="custom-bg-color pt-20">
    <h1 class="text-center featured-video-header" *ngIf="featured_videos?.length > 0">FEATURED VIDEO CONTENT</h1>
    <div id="myCarousel3" class="carousel" data-ride="carousel" [noPause]=true data-pause="true" data-interval="8000">
        <div class="carousel-inner featured-video-carousel pl7 pr7" *ngIf="featured_videos?.length > 0">
            <div *ngFor="let video of featured_videos; let i = index" id="{{i}}"
                [ngClass]="{'carousel-item': i >= 0 || featured_videos?.length == 1, 'active': (i == 0 || featured_videos?.length == 1)}">
                <div class="featured-video-section custom-bg-color">
                    <div class="text-center featured-video align-items-center">
                        <!-- Play button overlay -->
                        <div *ngIf="showPlayBtn && video.data.data?.video_thumbnail_image" 
                             (click)="playVideo(i, video)"
                             class="position-absolute play-btn d-none d-lg-block" 
                             style="cursor: pointer; z-index: 10;">
                            <app-svg [icon]="'play-button-dark'"></app-svg>
                        </div>
                        
                        <!-- Fixed video element - removed duplicate muted attributes and autoplay -->
                        <video [id]="'bannerVideo' + i" 
                               class="video100"
                               muted
                               playsinline
                               preload="metadata"
                               (timeupdate)="timeUpdate($event)"
                               (ended)="pauseVideo()"
                               [poster]="video.data.data?.video_thumbnail_image ? video.data.data?.video_thumbnail_image : default_image"
                               controls>
                            <!-- Don't set src here, it will be set dynamically -->
                            <source type="video/mp4">
                        </video>
                    </div>
                    <div class="text-center mt-15">
                        <h3 class="fs-25 mb-5">{{video.data.data?.stream_video_title}}</h3>
                        <h5 class="fs-20">{{video.data.data?.channel_name}}</h5>
                        <!-- <div class="btn-effect">
                                    <div class="effect-1 explore-e-btn"></div>
                                    <div class="effect-2 explore-e-btn"></div>
                                    <div class="effect-3 explore-e-btn"></div> -->
                        <button mat-flat-button 
                                class="explore-btn flat-primary-button tertiary-bg-button mt-10"
                                (click)="goToAlbum(video.data?.data)">
                            Explore
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <ol class="carousel-indicators pt-20">
            <li *ngFor="let a of featured_videos; let j = index" 
                [ngClass]="{'active': j == 0}"
                [attr.data-slide-to]="j" 
                data-target="#myCarousel3" 
                (click)="pauseVideo()">
            </li>
        </ol>
    </div>
</div>
        <!-- Featured video content  -->
        <!--Featured Audio content-->
        <div class="featured-audio-header text-center mt-50" *ngIf="featured_audios?.length > 0">FEATURED AUDIO CONTENT
        </div>
        <div class="featured-audio-carousel" *ngIf="featured_audios?.length > 0">
            <div class="featured-audio">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="featured-audio-left d-flex justify-content-center align-items-center mx-auto"
                            [ngStyle]="{'background-image': 'url(' + featured_audios[0]?.data.data.video_thumbnail_image + ')'}">
                            <a class="listen-now d-none d-md-block"
                                (click)="goToAlbum(featured_audios[0]?.data.data)">LISTEN NOW<span class="ml-3"><i
                                        class="fa fa-light fa-arrow-right"></i></span></a>
                            <div class="overlay d-none d-md-block"></div>
                        </div>

                        <div class="content d-none d-md-block">
                            <div class="fs-22 mt-5 title">{{featured_audios[0]?.data.data?.stream_video_title}}</div>
                            <div class="d-flex align-items-center fw-500">
                                <label>{{featured_audios[0]?.data.data?.organization_name}}</label>
                                <div class="small-dot" *ngIf="featured_audios[0]?.data.data?.release_year"></div>
                                <label>{{featured_audios[0]?.data.data?.release_year}}</label>
                            </div>

                        </div>
                    </div>
                    <div class="d-block d-md-none d-flex featured-audio-right " *ngIf="featured_audios?.length > 0">
                        <ng-container *ngFor="let audio of featured_audios; let i = index">
                            <div class="col-5 mr-20" *ngIf="i>0 && i<=4">
                                <div class="image"
                                    [ngStyle]="{'background-image': 'url(' + audio.data.data.video_thumbnail_image + ')'}"
                                    (click)="goToAlbum(featured_audios[0]?.data.data)"></div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="col-6 featured-audio-right d-none d-md-block">
                        <div class="row " *ngIf="featured_audios?.length > 0">
                            <ng-container *ngFor="let audio of featured_audios ; let i = index">
                                <div class="col-5" *ngIf="i>0 && i<=4" (click)="goToAlbum(audio.data.data)">
                                    <div class="image"
                                        [ngStyle]="{'background-image': 'url(' + audio.data.data.video_thumbnail_image + ')'}">
                                    </div>
                                    <div class="fs-18 mt-5 title">{{audio.data.data?.stream_video_title}}</div>
                                    <div class="d-flex align-items-center mb-5 fs-14 fw-500">
                                        <label>{{audio?.data.data.organization_name}}</label>
                                        <span class="small-dot" *ngIf="audio?.data.data?.release_year"></span>
                                        <label>{{audio?.data.data?.release_year}}</label>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div>

                    </div>
                </div>
            </div>
        </div>

        <!-- Featured Audio Content  -->
        <!-- Past Events  -->
        <div class="past-events" *ngIf="featured_past_events?.length > 0">
            <div class="past-events-header text-center">Past Events</div>
            <div class="images" id="past-event-container">
                <div class="d-flex" *ngIf="featured_past_events?.length > 0">
                    <div *ngFor="let event of featured_past_events"
                        [ngStyle]="{'background-image': 'url(' + event.data.data?.event_home_banner+ ')'}"
                        class="image relative" (click)="goToPastEvent(event.data.data)">
                        <div class="content">
                            <div class="past-event-logo"
                                [ngStyle]="{'background-image': 'url(' + event.data.data?.event_logo + ')'}"></div>
                            <label class="past-event-title">{{event.data.data?.stream_video_title}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Charities section  -->
        <!-- <div class="charities" *ngIf="featured_charities?.length > 0">
            <h1 class="charities-header text-center">SUPPORT OUR CHARITIES</h1>
            <div class="row images">
                    <div *ngFor="let charity of featured_charities" class="col-3 image d-none d-md-block" [ngStyle]="{'background-image': 'url(' + charity?.data?.data?.charity_logo + ')'}" (click)="navigateToCharity(charity?.data?.data?.charity_id)"></div>
                   <div class="mobile-charities"><div *ngFor="let charity of featured_charities" class="col-10 image d-block d-md-none" [ngStyle]="{'background-image': 'url(' + charity?.data?.data?.charity_logo + ')'}"  (click)="navigateToCharity(charity?.data?.data?.charity_id)"></div></div>
            </div> -->
        <!-- <div class="text-center"><button class="view-btn flat-primary-button">View More</button></div> -->
        <!-- </div> -->
        <!-- section4 -->
        <section class="last-banner">
            <div class="container m-auto">
                <div class="row creators">
                    <div class="col-sm-12 col-md-9 text-left">
                        <h1 class="txt-last">FOR CREATORS<br> <span class="fs-22 fw-400">Deliver fan experiences
                                globally</span>
                        </h1>

                    </div>
                    <div class="col-sm-12 col-md-3 text-center text-lg-right justify-content-center mb-2">
                        <div class="fw-600 text-uppercase last-div-banner">
                            <!-- <div class="effect-1 get-in-t"></div>
                        <div class="effect-2 get-in-t"></div>
                        <div class="effect-3 get-in-t"></div> -->
                            <button mat-flat-button class="mt-15 flat-primary-button get-in-touch-btn fw-500 mb-2"
                                routerLink="/contactus" (click)="GetInTouch()">GET IN
                                TOUCH</button>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    </div>